// extracted by mini-css-extract-plugin
export default {"root":"_2xiui","notFound":"_8NS56"};